import { getSiteInfo } from '../SiteConfigs.js';

function init_ga_analytics(){

    let SITE_INFO = getSiteInfo();
    
    if(SITE_INFO["google_analytics_id"] && SITE_INFO["google_analytics_id"] !==null)
    {
        load_scripts(SITE_INFO["google_analytics_id"]);
    }
    
    if(SITE_INFO['google_analytics4_id'] && SITE_INFO["google_analytics4_id"] !==null) 
    {
        load_scripts(SITE_INFO["google_analytics4_id"]);
    }
    
}

function load_scripts(analytics_id,){
    let ga = document.createElement('script');
    ga.type = 'text/javascript';
    ga.async = true;
    ga.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.googletagmanager.com/gtag/js?id=' + analytics_id;
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ga, s);

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', analytics_id);
    
}



export default init_ga_analytics;